__turbopack_export_value__({
  "floatingCallButton": "floatingCallButton-module-scss-module__-IMGCq__floatingCallButton",
});
